import type { IconSvgProps } from '../Icon.types';

export const Checks = ({ width, height }: IconSvgProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 256 256">
    <rect width="256" height="256" fill="none" />
    <polyline
      points="16 130.29 54.4 168 144 80"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
    <polyline
      points="125.96 144 150.4 168 240 80"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="16"
    />
  </svg>
);
